import React, { useEffect } from "react";
import { connect } from "react-redux";
import Loader from "../../../shared/loader";
import InvlidShootingDayNotification from "../invalid-shooting-day-notification";
import { fetchShootingDayMakeups } from "./ducks/actions";
import EditPropsForm from "./edit-form";

function ListShootingDayCrewContainer(props) {
  const { filmId, shootingDayId } = props.match.params;
  const {
    fetchShootingDayMakeups,
    loading,
    makeups,
    errors,
    readOnly
  } = props;

  useEffect(() => {
    fetchShootingDayMakeups(filmId, shootingDayId);
  }, [filmId, shootingDayId]);

  function renderLoading() {
    return <Loader />;
  }

  const anyMakeups = makeups?.length > 0;

  function renderShootingDays(makeups, filmId) {
    return (
      <div className="blade-content wide">
        <p className="menu-label">Hair and Makeup</p>
        {!anyMakeups && <div>None required on this day</div>}
        {anyMakeups && <EditPropsForm
          errors={errors}
          mode="edit"
          filmId={filmId}
          initialValues={{ makeups }}
          loading={loading}
          readOnly={readOnly}
          {...props}
        />}
      </div>
    );
  }

  if (!props.shootingDay?.hasValidSchedule) {
    return <InvlidShootingDayNotification />;
  }

  return loading ? renderLoading() : renderShootingDays(makeups, filmId);
}

function mapStateToProps(state) {
  const { rootState, makeupsState } = state.shootingdaysState;
  return {
    shootingDay: rootState.shootingday,
    readOnly: makeupsState.readOnly,
    makeups: makeupsState.makeups,
    loading: makeupsState.loading,
    errors: makeupsState.errors
  };
}

export default connect(mapStateToProps, {
  fetchShootingDayMakeups
})(ListShootingDayCrewContainer);
